import { useDraggable } from "@dnd-kit/core";
import { useEffect, useState } from "react";
import { dateOnlyFormatted } from "../../utils/systemSettings";
import styles from "./Kanban.module.scss";
// import scopeService from "../../store/services/scope.service";
import {
  // ArrowLeft,
  // ArrowRight,
  // CalendarIcon,
  CalendarIconDate,
  ChevronRightIcon,
  DeleteIcon,
  DoneBadge,
  EditIcon,
  InProgressBadge,
  MeatBallsMenuIcon,
  OnHoldBadge,
  SlippingBadge,
  ToDoBadge,
  AttachementIcon
} from "../../modules/default-svg";
// import { Avatar } from "@fluentui/react-avatar";
import {
  Avatar,
  Popover,
  PopoverSurface,
  PopoverTrigger,
  Tooltip,
} from "@fluentui/react-components";

import {
  AvatarGroup,
  AvatarGroupItem,
  AvatarGroupPopover,
  partitionAvatarGroupItems,
} from "@fluentui/react-components";
import { Copy } from "lucide-react";
import { TABLE_ACTIONS } from "../../components/controls/tables/utils/tableUtils";
import SafeHtml from "../../components/safeHtml/SafeHtml";
import HoverCard from "../../components/hoverCard/HoverCard";
import { MilestoneIcon } from "../dashboard/icons/icons";

const KanbanCard = (props) => {
  const {
    title,
    index,
    parent,
    details,
    setShowModal,
    selectedItem,
    setSelectedItem,
    setIsEdit,
    setModalTitle,
    setShowDeleteModal,
    handleMove,
    handleAction,
    isOverlay,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [setting] = useState(settings);
  const [descExpanded, setDescExpanded] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [lane, setLane] = useState([]);
  const [cardDetails, setCardDetails] = useState(details);
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: title,
    disabled: isOverlay || cardDetails?.status === 3, //disable drag on completed tasks 
    data: {
      title,
      index,
      parent,
      cardDetails,
    },
  });
  useEffect(() => {
    setCardDetails(details);
  }, [details]);

  const getPriorityStripe = (priority) => {
    switch (priority) {
      case 0:
        return styles.priorityLow;
      case 1:
        return styles.priorityModerate;
      case 2:
        return styles.priorityHigh;
      default:
        return "";
    }
  };

  const getPriority = (priority) => {
    switch (priority) {
      case 0:
        return "Low";
      case 1:
        return "Moderate";
      case 2:
        return "High";
      default:
        return "";
    }
  };

  const getPriorityPill = (priority) => {
    switch (priority) {
      case 0:
        return "pill OnTrack";
      case 1:
        return "pill OffTrack";
      case 2:
        return "pill AtRisk";
      default:
        return "";
    }
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setSelectedItem(cardDetails);
    setShowModal(true);
    setModalTitle(`Edit Task`);
    setIsEdit(true);
    setPopoverOpen(null);
  };

  const handleDelete = () => {
    setSelectedItem(cardDetails);
    setShowDeleteModal(true);
    setPopoverOpen(null);
  };

  const handleCardMove = (newStatus) => {
    setPopoverOpen(null);
    handleMove(newStatus);
  };

  const NestedPopOver = () => {
    return (
      <div className="listingPopoverContent">
        {lane.map((item) =>
          TaskStatusMap[item.name] != cardDetails.status && (
            <div className="popItem" onClick={() => handleCardMove(item.name)}>
              {item.icon}
              <p className="text-sm-400 ms-12">{item.name}</p>
            </div>
          )
        )}
      </div>
    );
  };

  useEffect(() => {
    if (selectedItem) {
      // const statusList = [{ id: 0, icon: <ToDoBadge />, name: "To Do" }, { id: 1, icon: <InProgressBadge />, name: "In Progress" }, { id: 2, icon: <DoneBadge />, name: "Done" }];
      const statusList = [
        { id: 4, icon: <OnHoldBadge />, name: "On Hold" },
        { id: 0, icon: <DoneBadge />, name: "In Progress" },
        { id: 1, icon: <InProgressBadge />, name: "Monitoring" },
        { id: 2, icon: <SlippingBadge />, name: "Slipping" },
        { id: 3, icon: <ToDoBadge />, name: "Completed" },
      ];
      const moveToLane = statusList.filter(
        (status) => status.name !== selectedItem.status
      );
      setLane(moveToLane);
    }
  }, [selectedItem]);

  const { inlineItems, overflowItems } = partitionAvatarGroupItems({
    items: cardDetails.allocations || [],
  });

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleDuplicate = () => {
    setSelectedItem(cardDetails);
    setPopoverOpen(null);

    if (handleAction) {
      handleAction({
        actionType: TABLE_ACTIONS.DUPLICATE,
        payload: {
          id: cardDetails.id,
          name: cardDetails.name,
        }
      });
    }
  };


  const TaskStatusMap = {
    "In Progress": 0,
    "Monitoring": 1,
    "Slipping": 2,
    "Completed": 3,
    "On Hold": 4,
  }
  // When used as overlay clone, render full card without drag bindings
  if (isOverlay) {
    return (
      <div className={`${styles.cardTaskWrap} ${styles.dragOverlay}`}>
        <div className={`${styles.cardTask}`}>
          <div className="d-flex align-items-start justify-content-between">
            <div style={{ minWidth: 0, flex: 1 }}>
              <div className={styles.cardRefRow}>
                {cardDetails.isMilestone && <MilestoneIcon size={16} />}
                <div className={styles.cardRefId}>{cardDetails.refId}</div>
                <div className="flex gap-1">
                  {cardDetails.progress != null && (
                    <span className={styles.phasePill}>{cardDetails.progress}%</span>
                  )}
                </div>
              </div>
              <div className={styles.cardTitle}>
                {cardDetails.name}
              </div>
              {(cardDetails.startDate || cardDetails.endDate) && (
                <div className={styles.dateSection}>
                  <CalendarIconDate />
                  <span>
                    {cardDetails.startDate
                      ? dateOnlyFormatted(setting, cardDetails.startDate)
                      : ""}
                    {cardDetails.startDate && cardDetails.endDate && " - "}
                    {cardDetails.endDate
                      ? dateOnlyFormatted(setting, cardDetails.endDate)
                      : ""}
                  </span>
                </div>
              )}
              {cardDetails.description && (
                <div className={styles.descriptionWrap}>
                  <SafeHtml
                    className={styles.cardDescription}
                    html={cardDetails.description}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={`${styles.statPills} d-flex`}>
            {cardDetails.attachementsCount > 0 && (
              <div className="mr-1">
                <AttachementIcon count={cardDetails.attachementsCount} />
              </div>
            )}
            {
              cardDetails.isCritical && (
                <span className={`pill AtRisk`}>
                  Critical
                </span>
              )
            }
            <Tooltip content="Priority" relationship="label">
              <span className={getPriorityPill(cardDetails.priority)}>
                {getPriority(cardDetails.priority)}
              </span>
            </Tooltip>
            {cardDetails.phase && (
              <Tooltip content={`Phase: ${cardDetails.phase}`} relationship="label">
                <span className={styles.phasePill}>{cardDetails.phase}</span>
              </Tooltip>
            )}
          </div>
          {inlineItems.length > 0 && (
            <div className={styles.cardFooter}>
              <div className="AvatarGroupWrapper">
                <AvatarGroup layout="stack" size={24}>
                  {inlineItems.map((item) => (
                    <AvatarGroupItem
                      name={item.resource.name}
                      image={{ src: item.resource.image }}
                      key={item.resource.name}
                    />
                  ))}
                </AvatarGroup>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={styles.cardTaskWrap}
      style={{ opacity: isDragging ? 0.3 : 1 }}
    >
      <div className={`${styles.cardTask}`} onClick={handleEdit}>
        {/* Header: title + menu */}
        <div className="d-flex align-items-start justify-content-between">
          <div style={{ minWidth: 0, flex: 1 }}>
            <div className={styles.cardRefRow}>
              {cardDetails.isMilestone && <MilestoneIcon size={18} />}
              <div className={styles.cardRefId}>{cardDetails.refId}</div>
              <div className="flex gap-1 ">
                {cardDetails.progress != null && (
                  <span className={styles.phasePill}>{cardDetails.progress}%</span>
                )}
                <span className={`${styles.meatballMenu} ${popoverOpen === cardDetails.id ? styles.meatballMenuActive : ''}`}>
                  <Popover
                    open={popoverOpen === cardDetails.id}
                    onOpenChange={(e, data) =>
                      handlePopoverOpen(prev => prev === cardDetails.id ? null : cardDetails.id)
                    }
                    positioning="below-end"
                    trapFocus
                  >
                    <PopoverTrigger>
                      <div
                        onClick={(e) => e.stopPropagation()}
                      >
                        <MeatBallsMenuIcon />
                      </div>
                    </PopoverTrigger>
                    <PopoverSurface style={{ zIndex: 1000 }} className="listingPopoverWrapper">
                      <div className="listingPopoverContent">
                        <div className="popItem" onClick={handleEdit}>
                          <EditIcon />
                          <p className="text-sm-400 ms-12">Edit</p>
                        </div>
                        <div
                          className="popItem"
                          onClick={(e) => { e.stopPropagation(); handleDuplicate() }}
                        >
                          <Copy size={16} />
                          <p className="text-sm-400 ms-12">Duplicate</p>
                        </div>
                        <div
                          className="popItem"
                          onClick={(e) => { e.stopPropagation(); handleDelete() }}
                        >
                          <DeleteIcon />
                          <p className="text-sm-400 ms-12">Delete</p>
                        </div>
                        {cardDetails.status !== "Completed" && cardDetails.progress < 100 && (
                          <Popover positioning="after-top" trapFocus>
                            <PopoverTrigger disableButtonEnhancement>
                              <div className="popItem" onClick={(e) => { e.stopPropagation(); setSelectedItem(cardDetails) }}>
                                <ChevronRightIcon />
                                <p className="text-sm-400 ms-12">Move</p>
                              </div>
                            </PopoverTrigger>
                            <PopoverSurface className="listingPopoverWrapper">
                              {NestedPopOver()}
                            </PopoverSurface>
                          </Popover>
                        )}
                      </div>
                    </PopoverSurface>
                  </Popover>
                </span>
              </div>
            </div>
            <div className={`${styles.cardTitle}`} >
              {cardDetails.name}
            </div>
            {/* Dates after title */}
            {(cardDetails.startDate || cardDetails.endDate) && (
              <div className={styles.dateSection}>
                <CalendarIconDate />
                <span>
                  {cardDetails.startDate
                    ? dateOnlyFormatted(setting, cardDetails.startDate)
                    : ""}
                  {cardDetails.startDate && cardDetails.endDate && " - "}
                  {cardDetails.endDate
                    ? dateOnlyFormatted(setting, cardDetails.endDate)
                    : ""}
                </span>
              </div>
            )}
            {/* Description with read more */}
            {cardDetails.description && (
              <div className={styles.descriptionWrap}>
                <SafeHtml
                  className={descExpanded ? styles.cardDescriptionExpanded : styles.cardDescription}
                  html={cardDetails.description}
                />
                <span
                  className={styles.readMoreBtn}
                  onClick={(e) => { e.stopPropagation(); setDescExpanded(!descExpanded); }}
                >
                  {cardDetails.description.trim().length <= 100 ? "" : (descExpanded ? "Show less" : "Read more")}
                </span>
              </div>
            )}
          </div>
        </div>

        {/* Priority + Phase row */}
        <div className={`${styles.statPills} d-flex`}>
          {cardDetails.attachementsCount > 0 && (
            <div className="mr-1">
              <AttachementIcon count={cardDetails.attachementsCount} />
            </div>
          )}
          {
            cardDetails.isCritical && (
              <span className={`pill AtRisk`}>
                Critical
              </span>
            )
          }
          <Tooltip content="Priority" relationship="label">
            <span className={getPriorityPill(cardDetails.priority)}>
              {getPriority(cardDetails.priority)}
            </span>
          </Tooltip>
          {cardDetails.phase && (
            <Tooltip content={`Phase: ${cardDetails.phase}`} relationship="label">
              <span className={styles.phasePill}>{cardDetails.phase}</span>
            </Tooltip>
          )}
        </div>

        {/* Footer: assignees only */}
        {inlineItems.length > 0 && (
          <div className={styles.cardFooter}>
            <div className="AvatarGroupWrapper">
              <AvatarGroup layout="stack" size={24}>
                {inlineItems.map((item) => (
                  <HoverCard
                    HoverCardTrigger={
                      <div>
                        <Avatar
                          size={28}
                          color="colorful"
                          name={item.resource.name}
                          image={{ src: item.resource.image || null }}
                        />
                      </div>
                    }
                    AvatarId={item.resource.id}
                    AvatarName={item.resource.name}
                    AvatarImage={item.resource.image}
                    AvatarDesignation={item.resource.title}
                    AvatarEmail={item.resource.email}
                    AvatarPhone={item.resource.phoneNumber}
                    AvatarIsExternal={item.resource.isExternal}
                    CanSendMessage={true}
                  />
                ))}
                {overflowItems && (
                  <AvatarGroupPopover>
                    {overflowItems.map((item) => (
                      <HoverCard
                        HoverCardTrigger={
                          <div>
                            <Avatar
                              size={28}
                              color="colorful"
                              name={item.resource.name}
                              image={{ src: item.resource.image || null }}
                            />
                          </div>
                        }
                        AvatarId={item.resource.id}
                        AvatarName={item.resource.name}
                        AvatarImage={item.resource.image}
                        AvatarDesignation={item.resource.title}
                        AvatarEmail={item.resource.email}
                        AvatarPhone={item.resource.phoneNumber}
                        AvatarIsExternal={item.resource.isExternal}
                        CanSendMessage={true}
                      />
                    ))}
                  </AvatarGroupPopover>
                )}
              </AvatarGroup>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default KanbanCard;
